export const data = [
  {
    start: 10,
    end: 15,
    title: 'Element 1',
    elementId: 'element-1',
    type: 'text',
    positionHorizontal: 'right',
    positionVertical: 'bottom',
    headline: 'A',
    text: 'Notiere diesen Buchstaben:',
    internalLink: {}
  },

  {
    start: 20,
    end: 25,
    title: 'Element 2',
    elementId: 'element-2',
    type: 'url',
    positionHorizontal: 'left',
    positionVertical: 'bottom',
    url: 'https://www.ambion.de/',
    urlText: 'www.ambion.de',
    text: 'Schau diesen Link an:',
    internalLink: {
      title: 'Etwas vergessen?',
      linkTitle: 'Schau mal hier!',
      link: '/element-1'
    }
  }
];
